export const usersDataActions = {
  populateUsersData: "POPULATE_USERS_DATA",
  usersDataLoading: "USERS_DATA_LOADING",
  usersLoadError: "USERS_LOAD_ERROR",
  populateCurrentUserData: "POPULATE_CURRENT_USER_DATA"
};
